import { useState } from 'react';
import { observer } from 'mobx-react-lite';

import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import Button from '@mui/joy/Button';
import Input from '@mui/joy/Input';

// import { Divider } from '@mui/joy';

// import useIdentity from 'hooks/useIdentity';
// import useTeam from 'hooks/useTeam';
// import useUserIdentity from 'hooks/useUserIdentity';

import Success from 'components/Success';
// import Lore from 'components/Lore';
// import IdentityAvatar from 'components/IdentityAvatar';

// import { money } from 'utils/misc';
// import LoadingSection from './LoadingSection';
// import { TeamType } from 'stores/team_store';

import useUser from 'hooks/useUser';
import CardLoggedOut from './CardLoggedOut';



const SignUpContainer = observer(() => {
    // const { , fetchMyTeam, getTeam, items } = useTeam();

    const { signupEmailStart } = useUser();
    // const { currentIdentity } = useUserIdentity();
    // const [fetched, setFetched] = useState(false);
    const [confirming, setConfirming] = useState(false);
    const [sent, setSent] = useState(false);
    const [email, setEmail] = useState('');



    function signupConfirmStart() {
        setConfirming(true);
        console.log('signupConfirmStart', email);
        signupEmailStart(email)
            .then(() => {
                Success('Great. Check your email!');
                setConfirming(false);
                setSent(true);
            })
    }


    return (
        <CardLoggedOut>
            {sent &&
                <Stack alignItems="center" my={2}>
                <Typography level="title-lg">Sent! Check your email.</Typography>
                </Stack>
            }
        { !sent &&
        <Stack my={2} spacing={1}>

                <Typography level="title-lg">Create an Account</Typography>
                <Input
                    disabled={confirming}
                    placeholder="Enter your email address"
                    onChange={(e) => setEmail(e.target.value)}
                />
                <Button
                    disabled={confirming}
                    onClick={() => signupConfirmStart()}>Confirm</Button>
                <Stack alignItems="center" pt={1}>
                    <Typography level="body-xs">We'll send you an email to confirm this</Typography>
                </Stack>
            </Stack>
        }
        </CardLoggedOut>
    );
});
export default SignUpContainer;
